import Vue from 'vue'
import Router from 'vue-router'
import qs from 'qs'
import routes, { RouteNames } from '@/router/routes'
import store from '@/store'
import { Getters } from '@/store/getters'
import { Actions } from '@/store/actions'
import { navigationGuard } from '@/router/guards'

Vue.use(Router)
// noinspection JSUnusedGlobalSymbols
Vue.prototype.$routeNames = RouteNames

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes,
  // set custom query resolver
  parseQuery(query) {
    return qs.parse(query)
  },
  stringifyQuery(query) {
    const result = qs.stringify(query)

    return result ? ('?' + result) : ''
  },
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth'
      }
    }
    return { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  if (from.name === null) {
    // first request, check auth
    await store.dispatch(Actions.AUTH_INIT)
  }

  const isAuthenticated = store.getters[Getters.IS_AUTHENTICATED]
  const appInitialized = store.getters[Getters.APP_INITIALIZED]

  // if authenticated - load crucial app data
  if (isAuthenticated && !appInitialized) {
    await store.dispatch(Actions.APP_INIT)
  }

  // Public routes that don't require authentication
  const publicRoutes = [
    RouteNames.LOGIN,
    RouteNames.FINISH_SIGNUP,
    RouteNames.CREATE_PASSWORD,
    RouteNames.FORGOT_PASSWORD,
    RouteNames.SIGNUP
  ]

  if (!isAuthenticated && !publicRoutes.includes(to.name as string)) {
    // trying to get auth page && auth false
    next({ name: RouteNames.LOGIN })
  } else if (isAuthenticated && to.name === RouteNames.LOGIN) {
    // trying to get login page && auth true
    next({ name: RouteNames.OVERVIEW })
  } else {
    // Check route-specific abilities/permissions
    await navigationGuard(to, from, next)
  }
})

export default router
